<div *ngIf="requirementsByTestCase?.length > 0 || requirementsByResult?.length > 0">
	<div class="no-padding col-md-12">
		<!-- <span class="col-md-3 results-filter-empty"></span> -->
		<span class="checkbox-show-history">
			<fieldset class="results-filter-fieldset">
				<label>
					{{ labelShowAll }}&nbsp;
					<input class="checkbox" type="checkbox" (change)="showHistory($event.target.checked)" />
				</label>
			</fieldset>
		</span>
	</div>
	<table mat-table [dataSource]="dataSource" multiTemplateDataRows>
		<ng-container matColumnDef="requirement.requirementId">
			<th mat-header-cell *matHeaderCellDef>Requirement ID</th>
			<td mat-cell *matCellDef="let element">
				<a href="{{ requirementsurl }}workitem?id={{ element.requirement.requirementId }}&revision={{ element.requirement.version }}" target="_blank">
					<u>
						<span class="scania-link" title="Link to Polarion for this requirement and version">
							<b>{{ element.requirement.requirementID }}</b>
						</span>
					</u>
				</a>
			</td>
		</ng-container>
		<ng-container matColumnDef="requirement.version">
			<th mat-header-cell *matHeaderCellDef>IRMA version</th>
			<td mat-cell *matCellDef="let element">
				<a href="{{ requirementsurl }}workitem?id={{ element.requirement.requirementId }}&revision={{ element.requirement.version }}" target="_blank">
					<u>
						<span class="scania-link" title="Link to Polarion for this requirement and version">
							<b>{{ element.requirement.irmaVersion }}</b>
						</span>
					</u>
				</a>
			</td>
		</ng-container>
		<ng-container matColumnDef="requirement.name">
			<th mat-header-cell *matHeaderCellDef [attr.colspan]="2">Requirement name</th>
			<td mat-cell *matCellDef="let element" [attr.colspan]="2">{{ element.requirement.name }}</td>
		</ng-container>
		<ng-container>
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let element"></td>
		</ng-container>
		<ng-container matColumnDef="requirement.asil">
			<th mat-header-cell *matHeaderCellDef>ASIL</th>
			<td mat-cell *matCellDef="let element">{{ element.requirement.asil }}</td>
		</ng-container>
		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{ resultRequirement: row.isResultRequirement === true }"></tr>
		<ng-container matColumnDef="testAnalysis.name">
			<th mat-header-cell *matHeaderCellDef class="padding-ta">Test analysis name</th>
			<td mat-cell *matCellDef="let element" class="padding-ta">{{ element.testAnalysis.name }}</td>
		</ng-container>
		<ng-container matColumnDef="testAnalysis.version">
			<th mat-header-cell *matHeaderCellDef>Test analysis version</th>
			<td mat-cell *matCellDef="let element">{{ element.testAnalysis.version }}</td>
		</ng-container>
		<ng-container matColumnDef="testAnalysis.uid">
			<th mat-header-cell *matHeaderCellDef>Test analysis UID</th>
			<td mat-cell *matCellDef="let element">{{ element.testAnalysis.uid }}</td>
		</ng-container>
		<ng-container matColumnDef="testAnalysis.regTime">
			<th mat-header-cell *matHeaderCellDef>Test analysis creation time</th>
			<td mat-cell *matCellDef="let element">{{ element.testAnalysis.regTime | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
		</ng-container>
		<ng-container matColumnDef="testAnalysis.validTo">
			<th mat-header-cell *matHeaderCellDef>Test analysis valid to</th>
			<td mat-cell *matCellDef="let element">{{ element.testAnalysis.validTo | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
		</ng-container>
		<tr mat-header-row *matHeaderRowDef="displayedColumnsTA"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumnsTA" [ngClass]="{ resultRequirement: row.isResultRequirement === true }"></tr>
		<ng-container matColumnDef="testAnalysisAlternative.name">
			<th mat-header-cell *matHeaderCellDef class="padding-taalt">Test condition name</th>
			<td class="border-thick padding-taalt" mat-cell *matCellDef="let element" title="{{ element.testAnalysisAlternative.name }}">{{ element.testAnalysisAlternative.name }}</td>
		</ng-container>
		<ng-container matColumnDef="testAnalysisAlternative.version">
			<th mat-header-cell *matHeaderCellDef>Test condition version</th>
			<td class="border-thick" mat-cell *matCellDef="let element">{{ element.testAnalysisAlternative.version }}</td>
		</ng-container>
		<ng-container matColumnDef="testAnalysisAlternative.uid">
			<th mat-header-cell *matHeaderCellDef>Test condition UID</th>
			<td class="border-thick" mat-cell *matCellDef="let element">{{ element.testAnalysisAlternative.uid }}</td>
		</ng-container>
		<ng-container matColumnDef="testAnalysisAlternative.regTime">
			<th mat-header-cell *matHeaderCellDef>Test condition creation time</th>
			<td class="border-thick" mat-cell *matCellDef="let element">{{ element.testAnalysisAlternative.regTime | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
		</ng-container>
		<ng-container matColumnDef="testAnalysisAlternative.validTo">
			<th mat-header-cell *matHeaderCellDef>Test condition valid to</th>
			<td class="border-thick" mat-cell *matCellDef="let element">{{ element.testAnalysisAlternative.validTo | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
		</ng-container>
		<tr mat-header-row *matHeaderRowDef="displayedColumnsTAAlt"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumnsTAAlt" [ngClass]="{ resultRequirement: row.isResultRequirement === true }"></tr>
	</table>
</div>

<div *ngIf="requirementsByTestCase?.length === 0 && requirementsByResult?.length === 0" class="normal-text">There are no connected requirements</div>
